import { ButtonModalProps, EditorTabListProps } from 'spindl-shared-components';
import { HTMLEditorProps } from '../../organisms/HTMLEditor';
import { PreviewProps } from '../../organisms/Preview';
import { SettingsSideBarProps } from '../../organisms/SettingsSideBar';
import { TagsSideBarProps } from '../../organisms/TagsSideBar';
import { TemplateEditorSubNavProps } from '../../organisms/TemplateEditorSubNav';
import { LeftPanelStateEnum } from './types';
import { SendEmailMenuProps } from '../../molecules/SendEmailMenu';

type TemplateEditorPageInternalProps = {
  templateEditorSubNav?: TemplateEditorSubNavProps;
  editorTabList?: EditorTabListProps;
  hTMLEditor?: HTMLEditorProps;
  preview?: PreviewProps;
  leftPanel?: LeftPanelStateEnum;
  tagsSideBar?: TagsSideBarProps;
  settingsSideBar?: SettingsSideBarProps;
  warningModal?: ButtonModalProps;
  exitModal?: ButtonModalProps;
  testEmailMenu?: SendEmailMenuProps;
  showTestEmailMenu?: boolean;
  closeSettingsSideBarModal?: ButtonModalProps;
};

type TemplateEditorPagePropsValues = {
  '': TemplateEditorPageInternalProps;
};

//MANUAL OVERRIDE
const propValues: TemplateEditorPagePropsValues = {
  '': {
    templateEditorSubNav: {
      error: 'None',
    },
    editorTabList: {},
    hTMLEditor: {},
    preview: {
      state: 'Empty',
    },
    leftPanel: 'Collapsed',
    tagsSideBar: {
    },
    settingsSideBar: {
    },
    warningModal: {
    },
    exitModal: {
    },
  },
};

const getProps = (type: string): TemplateEditorPageInternalProps => {
  const values: TemplateEditorPageInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
